<template>
    <div class="orderresolution-list">
      <Toolbar :handle-add="addHandler" v-if="userHasAccess('orderresolution_edit')"/>
  
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex sm12>
            <h1><v-icon large>mdi-basket</v-icon>{{$t('order.resolutions')}}</h1>
          </v-flex>
          <v-flex lg12>
            <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
              <OrderResolutionFilterForm
                ref="filterForm"
                :values="filters"
                slot="filter"
              />
            </DataFilter>
  
            <br />
  
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="items"
    :items-per-page.sync="options.itemsPerPage"
  :footer-props="footer"
              :loading="isLoading"
              :loading-text="$t('global.loading')"
              :options.sync="options"
              :server-items-length="totalItems"
              class="elevation-1"
              item-key="@id"
              @update:options="onUpdateOptions"
              @click:row="showHandler"
  @contextmenu:row="showHandlerExt"
            >
  
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </template>
  
  <script>
  import { mapActions, mapGetters } from 'vuex';
  import { mapFields } from 'vuex-map-fields';
  import ListMixin from '../../mixins/ListMixin';
  
  import OrderResolutionFilterForm from '../../components/orderresolution/Filter';
  import DataFilter from '../../components/DataFilter';
  import Toolbar from '../../components/Toolbar';
  import AccessMixin from '../../mixins/AccessMixin';
  
  export default {
    name: 'OrderResolutionList',
    servicePrefix: 'OrderResolution',
    mixins: [ListMixin,AccessMixin],
    components: {
      Toolbar,
      OrderResolutionFilterForm,
      DataFilter
      // basket 
    },
    data() {
      return {
        headers: [
          { text: this.$t('global.name'), value: 'name' },
          { text: this.$t('order.quality'), value: 'quality' },
        ],
    selected: [],
  footer: {
    'itemsPerPageText': "",
  },
        options: {sortBy : ['name'], sortDesc : [false]}
      };
    },
    computed: {
      ...mapGetters('orderresolution', {
        items: 'list'
      }),
      ...mapFields('orderresolution', {
        deletedItem: 'deleted',
        error: 'error',
        isLoading: 'isLoading',
        resetList: 'resetList',
        totalItems: 'totalItems',
        view: 'view'
      })
    },
    methods: {
      ...mapActions('orderresolution', {
        getPage: 'fetchAll',
        deleteItem: 'del'
      })
    }
  };
  </script>
  